import { DialogService } from '@app/shared/dialog/dialog.service';
import { debounce } from '@app/utils/common';
import { FunctionQueue } from '@app/utils/function-queue';
import { Logger } from '@app/utils/logger';
import { PortalTranslatePipe } from '../shared/pipes/translate.pipe';
import { TranslationEditComponent } from './components/translation-edit/translation-edit.component';

// Filled with references to dom elements and cleared every time the user toggles the translator off
let map: { [key: string]: JQuery[] } = {};
const functionQueue: FunctionQueue = new FunctionQueue();

const debounced = debounce(function () {
  requestAnimationFrame(function () {
    $.extend($.expr[':'], {
      containsExact: $.expr.createPseudo(function (text: string) {
        return function (elem) {
          const match = removeComments(elem.innerHTML).trim() === text.trim();

          if (match) {
            Logger.debug('Match!', text.trim(), elem);
          }

          return match;
        };
      }),
    });

    functionQueue.call();
    functionQueue.clear();
    // map = {}
  });
}, 100);

export function transform(dialogService: DialogService, id, key, value, instance: PortalTranslatePipe) {
  const $root = $('portal-container');

  const f = () => {
    let $el = $(':containsExact(' + id + '):not(.portal-translation-element):first', $root);

    if ($el.length === 0) {
      $el = $(':contains(' + id + '):last', $root);
    }

    $el.addClass('portal-translation-element');

    const notEmpty = $el.length > 0;
    const notYetHandled = map[key] === undefined || !map[key].some((_) => _[0] === $el[0]);

    if (notEmpty && notYetHandled) {
      const text = $el.text();

      if (map[key] === undefined) {
        map[key] = [];
      }

      map[key].push($el);

      instance.value = value;
      instance.changeDetectorRef.detectChanges();

      $el.off('click').on('click', clickHandler(dialogService, key, value));
    }
  };

  // Push the function
  functionQueue.push(f);

  // And call the debounced function that will once call all functions after angular stopped rendering
  debounced();
}

function clickHandler(dialogService: DialogService, key: string, value: string) {
  return (event) => {
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();

    dialogService.open(TranslationEditComponent).withInput({
      key: key,
    });
  };
}

export function undoTransform() {
  functionQueue.clear();
  map = {};

  $('.portal-translation-element').removeClass('portal-translation-element').off('click');
}

function addKeyDownHandler() {
  $(document).on('keydown', keyDownHandler);
}

function keyDownHandler(event) {
  if (event.type === 'z') {
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();

    const f = (value) => {
      Object.values(map).forEach((elements) => {
        elements.forEach(($el) => {
          $el.toggleClass('portal-translation-element--highlight', value);
        });
      });
    };

    f(true);

    setTimeout(() => f(false), 500);
  }
}

function removeKeyDownHandler() {
  $(document).off('keydown', keyDownHandler);
}

/**
 * Removes comments from a string (ignores the fact that there could be more than one)
 * @param text
 */
function removeComments(text: string): string {
  let returnValue: string = text;

  const begin = text.indexOf('<!--') || text.length;
  const end = text.indexOf('-->');

  if (begin > -1) {
    returnValue = text.substring(0, begin);
  }

  if (end > -1) {
    // If there is an ending there will always be a beginning, that's why we can safely append
    returnValue += text.substring(end + 3);
  }

  return returnValue;
}
